export default __webpack_public_path__ + "static/media/BANKOEFFNUNGSZEITEN_DE_MANUAL.df74ce2d.png";